import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Oferta</h2>
                        <p>Fizjoterapia uroginekologiczna zajmuje się diagnozowaniem, leczeniem oraz profilaktyką dysfunkcji związanych z miednicą mniejszą, układem moczowo-płciowym i narządem rodnym.<br />Może pomóc w przypadku:</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <h5>Nietrzymania moczu, stolca, gazów</h5>
                            </div>
                            <div className="item">
                                <h5>Osłabienia mięśni dna miednicy, nadmiernego napięcia mięśni</h5>
                            </div>
                            <div className="item">
                                <h5>Obniżenia narządu rodnego oraz ścian pochwy</h5>
                            </div>
                            <div className="item">
                                <h5>Ciąży i przygotowanie do porodu</h5>
                            </div>
                            <div className="item">
                                <h5>Silnych bólów menstruacyjnych lub endometriozy</h5>
                            </div>
                            <div className="item">
                                <h5>Rozejścia mięśnia prostego brzucha</h5>
                            </div>
                            <div className="item">
                                <h5>Dyskomfortu wokół blizn po operacjach np. cesarskim cięciu</h5>
                            </div>
                            <div className="item">
                                <h5>Anorgazmii i zaburzeń seksualnych w tym bolesnego współżycia</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
